
import { defineComponent, ref, onMounted, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage } from "element-plus";
import type { ElForm } from "element-plus";
import { BoxCategory } from "@/store/modules/BoxCategoryModule"
import { BoxInfo, BoxType, BoxItemInfo, BoxLevelItemInfo } from "@/store/modules/BoxInfoModule"
import { Level } from "@/store/modules/LevelModule"
import { Plus } from "@element-plus/icons-vue"
import NewBoxItemInfoModal from "@/components/modals/forms/NewBoxItemInfoModal.vue"
import * as _ from 'lodash'

import { POINT_LABEL } from "@/core/config/labels";

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  components: {
    Plus,
    NewBoxItemInfoModal
  },
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("套系新增", ["套系管理;box_infos"])
      } else {
        setCurrentPageBreadcrumbs("套系编辑", ["套系管理;box_infos", route.params.id.toString()])
      }
    });

    const rules = ref({
      // name: [
      //   {
      //     required: true,
      //     message: "商圈名称不可为空",
      //     trigger: "change",
      //   },
      // ],
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const box_info = ref({} as BoxInfo)
    box_info.value.box_item_infos_attributes = []
    box_info.value.hidden_gifts_attributes = []
    box_info.value.box_level_item_infos_attributes = []
    box_info.value.box_reset_levels = '["SSSR"]'

    const onCancel = () => {
      router.push({ name: "box_infos" });
    };

    const onBoxInBoxChange = (val: boolean) => {
      if (!val) {
        box_info.value.box_product_id = null;
      }
    };

    const boxResetLevelsArray = computed({
      get() {
        try {
          const val = box_info.value.box_reset_levels;
          if (Array.isArray(val)) return val;
          return val ? JSON.parse(val) : ['SSSR'];
        } catch {
          return ['SSSR'];
        }
      },
      set(val: string[]) {
        box_info.value.box_reset_levels = JSON.stringify(val);
      }
    });

    const isNew = !route.params.id;

    var add_type = 'normal'
    var currentLevel = {} as any
    let nextTempId = -1

    const isSubmit = ref(false)

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (isSubmit.value) {
        return
      }

      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          isSubmit.value = true

          // 提交前清除临时 ID（负数），让后端自动创建
          const payload = JSON.parse(JSON.stringify(box_info.value))
          const stripTempIds = (arr: any[]) => {
            if (!arr) return
            arr.forEach(item => {
              if (item.id && item.id < 0) delete item.id
              if (item.box_item_infos_attributes) stripTempIds(item.box_item_infos_attributes)
            })
          }
          stripTempIds(payload.box_item_infos_attributes)
          stripTempIds(payload.hidden_gifts_attributes)
          stripTempIds(payload.box_level_item_infos_attributes)

          if (isNew) {
            store
              .dispatch(
                Actions.CREATE_BOX_INFO,
                payload
              )
              .then((res) => {
                ElMessage.success('创建成功')
                router.replace({ name: "box_info_edit", params: { id: res.id } })
              })
              .catch(() => {
                isSubmit.value = false
              });
          } else {
            store
              .dispatch(Actions.UPDATE_BOX_INFO, {
                id: route.params.id,
                values: payload,
              })
              .then(() => {
                ElMessage.success('保存成功')
                // 保存后重新拉取, 让新增赏品拿到后端真实 id;
                // 否则它们仍是临时负 id, 再次点提交会被当新记录重复创建
                return store.dispatch(Actions.GET_BOX_INFO, route.params.id)
              })
              .then(() => {
                box_info.value = store.getters.currentBoxInfo
                imageUrl.value = box_info.value.image_url?.startsWith("http")
                  ? box_info.value.image_url
                  : ""
                isSubmit.value = false
              })
              .catch(() => {
                isSubmit.value = false
              });
          }
        } else {
          isSubmit.value = false
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_BOX_INFO, route.params.id)
        .then(() => {
          box_info.value = store.getters.currentBoxInfo

          imageUrl.value = box_info.value.image_url?.startsWith("http")
            ? box_info.value.image_url
            : ""
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    const imageUrl = ref("")

    const onChange = (file) => {
      var reader = new FileReader();
      reader.readAsDataURL(file.raw)
      reader.onload = (e) => {
        imageUrl.value = e.target?.result?.toString() || ""
        box_info.value.image = imageUrl.value
      }
    }

    const box_categories = ref(Array<BoxCategory>())

    store
      .dispatch(Actions.GET_BOX_CATEGORIES)
      .then(() => {
        box_categories.value = store.getters.currentBoxCategories
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

      const event_options = ref([] as any)

      store
        .dispatch(Actions.GET_EVENTS)
        .then(() => {
          event_options.value = [{id: '', name: ''} as any]
          event_options.value = event_options.value.concat(store.getters.currentEvents)
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        })

    const box_types = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_BOX_TYPES)
      .then(() => {
        box_types.value = store.getters.currentBoxTypes
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const game_types = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_GAME_TYPES)
      .then(() => {
        game_types.value = store.getters.currentGameTypes
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const double_types = ref([] as any)

    if (!box_info.value.double_type) {
      box_info.value.double_type = 'nonp'
    }

    double_types.value.push({key: '无', value: 'nonp'})
    double_types.value.push({key: '个人双倍', value: 'person'})
    double_types.value.push({key: '全场双倍', value: 'global'})

    // const item_levels = ref(Array<BoxType>())

    const item_levels = (item) => {
      switch (item.item_type) {
        case 'normal':
          return ['SSSR', 'SSR', 'SR', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        case 'range_gift':
          return ['FIRST', 'LAST', 'SP', 'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 'SP6', 'SP7', 'SP8', 'SP9', 'SP10', 'SP11', 'SP12', 'SP13', 'SP14', 'SP15', 'SP16', 'SP17', 'SP18', 'SP19', 'SP20']
        case 'run_gift':
          return ['RUN', 'RUN1', 'RUN2', 'RUN3', 'RUN4', 'RUN5', 'RUN6', 'RUN7', 'RUN8', 'RUN9', 'RUN10', 'RUN11', 'RUN12', 'RUN13', 'RUN14', 'RUN15', 'RUN16', 'RUN17', 'RUN18', 'RUN19', 'RUN20']
        default:
          return []
      }
    }

    // store
    //   .dispatch(Actions.GET_BOX_ITEM_LEVELS)
    //   .then(() => {
    //     item_levels.value = store.getters.currentBoxItemLevels
    //   })
    //   .catch(() => {
    //     // const [error] = Object.keys(store.getters.getErrors);
    //     // Swal.fire({
    //     //   text: store.getters.getErrors[error],
    //     //   icon: "error",
    //     //   buttonsStyling: false,
    //     //   confirmButtonText: "Try again!",
    //     //   customClass: {
    //     //     confirmButton: "btn fw-bold btn-light-danger",
    //     //   },
    //     // });
    //   })

    const box_item_types = ref(Array<BoxType>())
    const level_box_item_types = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_BOX_ITEM_TYPES)
      .then(() => {
        box_item_types.value = store.getters.currentBoxItemTypes
        level_box_item_types.value = store.getters.currentBoxItemTypes.filter((i) => { return i.value === 'normal' })
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const level_types = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_BOX_LEVEL_TYPES)
      .then(() => {
        level_types.value = store.getters.currentBoxLevelTypes
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })
    
    const box_level_item_info_gift_types = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_BOX_LEVEL_ITEM_INFO_GIFT_TYPES)
      .then(() => {
        box_level_item_info_gift_types.value = store.getters.currentBoxLevelItemInfoGiftTypes
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const destroy_item = (item) => {
      item._destroy = 1
    }

    const add_box_item_infos = (products) => {
      products.forEach((i) => {
        if (add_type == 'normal') {
          box_info.value.box_item_infos_attributes.push({
            id: nextTempId--,
            product_id: i.id,
            brand: i.brand,
            product: i.name,
            price: i.price,
            recycle_price: i.recycle_price,
            item_type: 'normal',
            quantity: 1,
            range_from: 0,
            range_to: 0,
            sorting: box_info.value.box_item_infos_attributes.length,
            is_water: i.is_water,
            combo_count: 0
          } as BoxItemInfo)
        } else if (add_type == 'hidden') {
          box_info.value.hidden_gifts_attributes.push({
            id: nextTempId--,
            product_id: i.id,
            brand: i.brand,
            product: i.name,
            price: i.price,
            recycle_price: i.recycle_price,
            percent: 0
          } as any)
        } else if (add_type == 'level') {
          currentLevel.box_item_infos_attributes.push({
            id: nextTempId--,
            product_id: i.id,
            brand: i.brand,
            product: i.name,
            price: i.price,
            recycle_price: i.recycle_price,
            item_type: 'normal',
            quantity: 1,
            range_from: 0,
            range_to: 0,
            sorting: currentLevel.box_item_infos_attributes.length,
            is_water: i.is_water,
            combo_count: 0,
            level_type: 'no_change'
          } as any)
        } else if (add_type == 'levelInfo') {
          currentLevel.product_name = `${i.brand}_${i.ip}_${i.name}`
          currentLevel.product_id = i.id
        }
      })
    }

    const move_up = (item, level?: BoxLevelItemInfo) => {
      if (item.sorting > 0) {
        item.sorting -= 1
      }

      let sorting_items

      if (level !== undefined) {
        sorting_items = _.orderBy(level.box_item_infos_attributes, 'sorting', 'asc').filter((i) => {
          return i != item
        })
      } else {
        sorting_items = _.orderBy(box_info.value.box_item_infos_attributes, 'sorting', 'asc').filter((i) => {
          return i != item
        })
      }

      for(var i = 0; i < sorting_items.length; i++) {
        if (i >= item.sorting) {
          sorting_items[i].sorting = i + 1
        } else {
          sorting_items[i].sorting = i
        }
      }
    }

    const move_down = (item, level?: BoxLevelItemInfo) => {
      let sorting_items

      if (level !== undefined) {
        if (item.sorting < level.box_item_infos_attributes.length - 1) {
          item.sorting += 1
        }

        sorting_items = _.orderBy(level.box_item_infos_attributes, 'sorting', 'asc').filter((i) => {
          return i != item
        })
      } else {
        if (item.sorting < box_info.value.box_item_infos_attributes.length - 1) {
          item.sorting += 1
        }

        sorting_items = _.orderBy(box_info.value.box_item_infos_attributes, 'sorting', 'asc').filter((i) => {
          return i != item
        })
      }

      for(var i = 0; i < sorting_items.length; i++) {
        if (i >= item.sorting) {
          sorting_items[i].sorting = i + 1
        } else {
          sorting_items[i].sorting = i
        }
      }
    }

    const orderedBoxItemInfos = computed(() => {
      return _.orderBy(box_info.value.box_item_infos_attributes, 'sorting', 'asc')
    })

    const orderedLevelBoxItemInfos = (level) => {
      return _.orderBy(level.box_item_infos_attributes, 'sorting', 'asc')
    }

    const current_role = ref('')

    if (store.getters.currentUser) {
      current_role.value = store.getters.currentUser.role
    }

    // 换算比例常量
    const POINT_PRICE = 0.1

    // 套系总金额，根据 box_type 换算现金价值
    // cash, extra_point: 1:1
    // membership_point: 0.1
    const box_info_total = (level: any = null) => {
      let amount = 0
      if (level) {
        amount = box_info.value.price * total_count(level)
      } else {
        amount = box_info.value.price * total_count()
      }

      if (box_info.value.box_type == 'membership_point') {
        return amount * POINT_PRICE
      }
      return amount
    }

    // 计算商品成本，根据 recycle_type 换算现金价值
    // balance, extra_point, point: 1:1
    // membership_point: 0.1
    const calculate_item_cost = (item: any, quantity: number) => {
      const price = item.recycle_price * quantity
      if (item.recycle_type == 'membership_point') {
        return price * POINT_PRICE
      }
      return price
    }

    const item_total = (level: any = null) => {
      let total = 0
      let data = [] as any
      const count = total_count(level)

      if (level) {
        data = level.box_item_infos_attributes
      } else {
        data = box_info.value.box_item_infos_attributes
      }

      // 排除已删除的项
      data = data.filter((i) => i._destroy != 1)

      // normal, infinity_surprise, gift, last_gift, combo 直接用 quantity
      data.filter((i) => {
        return ['normal', 'infinity_surprise', 'gift', 'last_gift', 'combo'].includes(i.item_type)
      }).forEach((i) => {
        total += calculate_item_cost(i, i.quantity)
      })

      // range_gift/run_gift 需要计算发放次数: Math.floor(count / range_to) * quantity
      // 使用 Math.floor 与后端整数除法保持一致
      data.filter((i) => {
        return i.item_type == 'range_gift'
      }).forEach((i) => {
        total += calculate_item_cost(i, Math.floor(count / i.range_to) * i.quantity)
      })

      data.filter((i) => {
        return i.item_type == 'run_gift'
      }).forEach((i) => {
        total += calculate_item_cost(i, Math.floor(count / i.range_to) * i.quantity)
      })

      return total
    }

    const total_profit = (level: any = null) => {
      if (level) {
        return box_info_total(level) - item_total(level)
      } else {
        return box_info_total() - item_total()
      }
    }

    const total_profit_percent = (level: any = null) => {
      if (level) {
        return Math.round((total_profit(level) / box_info_total(level)) * 100) + '%'
      } else {
        return Math.round((total_profit() / box_info_total()) * 100) + '%'
      }
    }

    const total_count = (level: any = null) => {
      let total = 0

      if (level) {
        level.box_item_infos_attributes.filter((i) => {
          return i._destroy != 1 && ['normal', 'infinity_surprise'].includes(i.item_type)
        }).forEach((i) => {
          total += i.quantity
        })
      } else {
        box_info.value.box_item_infos_attributes.filter((i) => {
          return i._destroy != 1 && ['normal', 'infinity_surprise'].includes(i.item_type)
        }).forEach((i) => {
          total += i.quantity
        })
      }

      return total
    }

    const LEVEL_ORDER = ['SSSR', 'SSR', 'SR', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

    const level_count_summary = (level: any = null) => {
      let data = [] as any
      if (level) {
        data = level.box_item_infos_attributes
      } else {
        data = box_info.value.box_item_infos_attributes
      }

      const countMap: Record<string, number> = {}
      data.filter((i) => i._destroy != 1 && i.item_type === 'normal' && i.level).forEach((i) => {
        const lvl = i.level as string
        countMap[lvl] = (countMap[lvl] || 0) + (i.quantity || 0)
      })

      return Object.keys(countMap)
        .sort((a, b) => {
          const ai = LEVEL_ORDER.indexOf(a) === -1 ? 999 : LEVEL_ORDER.indexOf(a)
          const bi = LEVEL_ORDER.indexOf(b) === -1 ? 999 : LEVEL_ORDER.indexOf(b)
          return ai - bi
        })
        .map(lvl => `${lvl}: ${countMap[lvl]}`)
        .join(' | ')
    }

    const levels = ref(Array<Level>())

    store
      .dispatch(Actions.GET_LEVELS)
      .then(() => {
        levels.value = store.getters.currentLevels
        levels.value.unshift({id: null} as any)
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const box_products = ref(Array<BoxType>())
    const eat_products = ref(Array<BoxType>())
    const cook_products = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_BOX_PRODUCTS)
      .then(() => {
        box_products.value = store.getters.currentBoxProducts
        eat_products.value = store.getters.currentEatProducts
        cook_products.value = store.getters.currentCookProducts
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const setAddType = (type, level) => {
      add_type = type
      currentLevel = level
    }

    const addLevel = () => {
      let box_level_item_info = {} as BoxLevelItemInfo
      box_level_item_info.level = getLastLevel() + 1
      box_level_item_info.box_item_infos_attributes = []
      box_info.value.box_level_item_infos_attributes.push(box_level_item_info)
    }

    const getLastLevel = () => {
      return box_info.value.box_level_item_infos_attributes.filter((i) => { return !i._destroy }).length
    }

    const destroyLevel = (level) => {
      level._destroy = 1
      console.log(level)

      let index = 1
      _.orderBy(box_info.value.box_level_item_infos_attributes, 'level', 'asc').filter((i) => { return !i._destroy }).forEach((i) => {
        console.log(i)
        i.level = index
        index++
      })
    }

    const sortByPrice = (level) => {
      const items = level
        ? level.box_item_infos_attributes
        : box_info.value.box_item_infos_attributes

      const sorted = _.orderBy(items, (i) => Number(i.recycle_price) || 0, 'desc')
      sorted.forEach((item, index) => {
        item.sorting = index
      })

      // 重新赋值数组触发 Vue 响应式更新
      if (level) {
        level.box_item_infos_attributes = [...items]
      } else {
        box_info.value.box_item_infos_attributes = [...items]
      }
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    const pointLabel = POINT_LABEL

    return {
      pointLabel,
      onSubmit,
      box_info,
      rules,
      onCancel,
      formRef,
      box_categories,
      imageUrl,
      onChange,
      box_types,
      game_types,
      item_levels,
      box_item_types,
      level_box_item_types,
      destroy_item,
      add_box_item_infos,
      move_up,
      move_down,
      orderedBoxItemInfos,
      orderedLevelBoxItemInfos,
      current_role,
      total_profit,
      total_profit_percent,
      total_count,
      level_count_summary,
      box_info_total,
      item_total,
      box_products,
      eat_products,
      cook_products,
      setAddType,
      levels,
      event_options,
      double_types,
      addLevel,
      destroyLevel,
      level_types,
      box_level_item_info_gift_types,
      sortByPrice,
      formatPrice,
      onBoxInBoxChange,
      boxResetLevelsArray
    }
  }
})
